import Checkbox from '@mui/material/Checkbox';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const attendanceCourseColumns = (
  selectedIds = [],
  handleToggleSelect
) => {
  return [
    {
      field: 'select',
      headerName: '',
      width: 55,
      sortable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',

      renderHeader: () => null,

      renderCell: (params) => (
        <Checkbox
          checked={selectedIds.includes(params?.row?.id)}
          onChange={(e) =>
            handleToggleSelect(params?.row?.id, e?.target?.checked)
          }
        />
      ),
    },
    {
      flex: 1,
      field: 'courseName',
      headerName: 'Course Name',
      renderCell: renderCellExpand,
    },
    {
      width: 85,
      headerName: 'Days',
      renderCell: renderCellExpand,
      field: 'numSchoolDaysSinceOnline',
    },
    {
      width: 90,
      headerName: 'Grade',
      field: 'actualGrade',
      renderCell: renderCellExpand,
    },
    {
      flex: 1,
      headerName: 'Last Online',
      field: 'lastOnlineActivity',
      renderCell: renderCellExpand,
    },
  ];
};
